import { Button } from 'antd';
import { fromBtn } from '../MessageExtend/styles';
import { useAdjustRelateKnowledge } from '@knowledge/knowledges/SupplementKnowledge/AdjustRelateKnowledge/useAdjustRelateKnowledge';
import { useQAPairSubmitQueryMsgIdsRecord } from 'hooks/business/im/useQAPairRecord';
import { useTranslate } from '@tolgee/react';
import { RightOutlined } from '@ant-design/icons';
import { useCallback } from 'react';
import { useMutation } from '@tanstack/react-query';
import { productList, ProductListParamsKeywordType } from 'services/api/conversation';
import { logger } from 'services/logger';

interface Props {
  extraInfo: Conversation.ExtraInfo;
  conversation: Conversation.Conversation;
  message: Conversation.Message;
  knowledgeQuery: Conversation.KnowledgeQueryMessage;
}

export const LLMQAReplyAction = (props: Props) => {
  const { message, conversation, extraInfo, knowledgeQuery } = props;
  const { t } = useTranslate();
  const { show: showAdjustRelateKnowledge } = useAdjustRelateKnowledge();
  const submitRecord = useQAPairSubmitQueryMsgIdsRecord();
  const reqMsgId = extraInfo.reqMsgId;
  const spuId = extraInfo.spuId;
  const { storeId, buyerId } = conversation;

  const isSubmitted = reqMsgId ? submitRecord.includes(`${reqMsgId}`) : false;

  const { isLoading, mutateAsync: queryItemInfo } = useMutation({
    mutationKey: ['queryItemInfo', spuId, storeId, buyerId],
    mutationFn: async () => {
      try {
        logger.info(`[LLMQAReplyAction] 查询商品[${spuId}]信息`);
        const response = await productList({
          page_no: 1,
          page_size: 1,
          internal_store_id: storeId,
          internal_buyer_id: buyerId,
          keyword: spuId,
          keyword_type: ProductListParamsKeywordType.ITEM_ID,
          needStockRule: false,
          ttsToko: false,
        });
        const result = response.itemList?.[0];
        if (!result) {
          logger.info(`[LLMQAReplyAction] 查询商品[${spuId}]不存在`);
          return undefined;
        }
        return result;
      } catch (error: any) {
        logger.error(
          `[LLMQAReplyAction] 查询商品[${spuId}]失败 ${error?.status} ${error?.message}`,
        );
        return undefined;
      }
    },
  });

  const handleClick = useCallback(async () => {
    if (!knowledgeQuery.itemInfo) {
      if (isLoading) {
        return;
      }
      const itemInfo = await queryItemInfo();
      if (itemInfo) {
        showAdjustRelateKnowledge({
          message,
          conversation,
          knowledgeQuery: {
            ...knowledgeQuery,
            itemInfo: { ...itemInfo, shopId: itemInfo.externalShopId },
          },
        });
        return;
      }
    }

    showAdjustRelateKnowledge({
      message,
      conversation,
      knowledgeQuery,
    });
  }, [knowledgeQuery, isLoading, queryItemInfo, showAdjustRelateKnowledge, message, conversation]);

  return (
    <Button type="link" className={fromBtn} onClick={handleClick}>
      {isSubmitted ? `${t('调整商品知识')}(${t('已提交')})` : t('调整商品知识')}
      <RightOutlined />
    </Button>
  );
};
